import React from 'react';
import { FormSection } from 'components/sections/form-section/form-section';
import { useVehicleDetailsVehicleFormSectionData } from './hooks/use-vehicle-form-section-data';

export const VehicleDetailsVehicleTabPanel = () => {
  const { vehicleFormSectionData } = useVehicleDetailsVehicleFormSectionData();
  return <FormSection title='Fahrzeug' data={vehicleFormSectionData} />;
};
